import * as API from '../api';
import {CREATEBOOK, UPDATEBOOK, DELETEBOOK, GETBOOK, GETALLBOOK, GETAMAZONBOOKS, GETCHEGGBOOKS} from '../constants/actionTypes';

export const createBook = (bookInformation) => async(dispatch) => {
    try{
        const {data} = await API.createBook(bookInformation);
        dispatch({type: CREATEBOOK, payload: data});
    } catch (error){
        console.log(error.message);
    }
}

export const getBooks = () => async(dispatch) => {
    try{
        const {data} = await API.getBooks();
        dispatch({type: GETBOOK, payload: data.mybooks});
    } catch (error){
        console.log(error.message);
    }
}

export const getAllBooks = (search) => async(dispatch) => {
    try{
        const {data} = await API.getAllBooks(search);
        dispatch({type: GETALLBOOK, payload: data.mybooks});
    } catch (error){
        console.log(error.message);
    }
}

export const updateBook = (id, bookInfo) => async (dispatch) => {
    try{
        const {data} = await API.updateBook(id, bookInfo);
        dispatch({type: UPDATEBOOK, data});      
    } catch (error){
        console.log(error.message);
    }
}


export const deleteBook = (id) => async(dispatch) => {
    try{
        const data = await API.deleteBook(id);
        dispatch({type: DELETEBOOK, id});
    } catch(error){
        console.log(error.message);
    }
}


export const getAmazonBooks = (search) => async(dispatch) => {
    try{
        const {data} = await API.getAmazonBooks(search);
        dispatch({type: GETAMAZONBOOKS, payload: data});
    } catch (error){
        console.log(error.message);
    }
}


export const getCheggBooks = (search) => async(dispatch) => {
    try{
        const {data} = await API.getCheggBooks(search);
        dispatch({type: GETCHEGGBOOKS, payload: data});
    } catch (error){
        console.log(error.message);
    }
}